
import { Component, Vue } from "vue-property-decorator";
import AdminUtils from "../components/AdminUtil.vue";

@Component({
  components: {
    AdminUtils,
  },
})
class Admin extends Vue {
  created(): void {
    this.$store.commit("authenication/setNavTab", 6);
  }
}

export default Admin;
